export default {
    labels: {
        roles: `Church Management Roles`,
        profileMapping: `Profile Mapping`,
        automations: `Automations`,
        profileFields: `Profile Fields`,
        history: `User Activity`,
        logs: `Organization Logs`,
        extensions: `Extensions`,
        songLibrary: `Song Library`,
        myOrganization: `My Organization`,
        bulk: `Bulk Tasks`,
        billing: `Billing`,
        givingIntegrations: `Giving Integrations`,
        userSettings: `User Settings`,
        notifications: `Notifications`
    },
    descriptions: {
        roles: `Assign custom Church Management permissions`,
        profileMapping: `Manage the links between users and their People profiles`,
        automations: `Create smart tags, schedule birthday emails, & more!`,
        profileFields: `Customize information stored on People profiles`,
        history: `View past activity including email and text history`,
        logs: `View, restore or export data`,
        extensions: `Manage integrations and additional features`,
        songLibrary: `Add and store songs for your setlist`,
        myOrganization: `Manage admin users, organization info and Giving locations`,
        bulk: `Manage People data by bulk importing and deleting`,
        billing: `Manage payment info and product subscriptions`,
        givingIntegrations: `Integrate giving data with other software`,
        userSettings: `Update your username and email credentials`,
        notifications: `Set email alerts for activity within your church`
    },
    tags: {
        upgrade: `Click here to upgrade`
    },
    badges: {
        upgrade: `Upgrade`
    },
    messages: `Messages`,
    inboxLite: {
        title: `Inbox`,
        new: `NEW`,
        newReplies: `{count} new reply | {count} new replies`,
        yesterday: `Yesterday`,
        empty: {
            title: `No new replies`,
            description: `When someone replies to a text you sent from their profile, it'll show up here.`,
            learnMore: `Learn more about two-way texting`
        },
        error: `We couldn't load your inbox.`,
        refreshError: `We couldn't refresh your inbox. Showing what we last loaded.`,
        retry: `Try again`
    },
    logout: `Logout`,
    mobileOrganizationSettings: `Users & Organization Settings`,
    usersAndOrganization: `My Organization`,
    manageYourAccount: `My Account`,
    churchManagement: `Church Management Settings`,
    myUser: `My User`
}
